import { Header } from './header';

export const MainLayout = (ps: { children: React.ReactNode }) => {
  return (
    <div>
      <div className="h-[90px]">
        <Header />
      </div>
      <main style={{ height: 'calc(100vh - 90px)' }}>{ps.children}</main>
    </div>
  );
};
